import React, { useState } from "react";
import { getLogedPid } from "../../userStore";
import { useSavePasswordMutation } from "../../redux/service/settings_service";
import { useSavePinMutation } from "../../redux/service/settings_service";
import { toast } from "react-toastify";
import  {getLoggedinUser, setLocalStorage} from "../../userStore";
import FullScreenLoader from "../../components/FullScreenLoader";

const Settings = () => {
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
  const [showResetPinForm, setShowResetPinForm] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [password, setPassword] = useState("");
  const [passwordValidationError, setPasswordValidationError] = useState(true);
  const [pinValidationError, setPinValidationError] = useState(true);
  const [showAccessParametersForm, setShowAccessParametersForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [savePassword] = useSavePasswordMutation();
  const [savePin] = useSavePinMutation();
  const handleResetPasswordClick = () => {
    setShowResetPasswordForm(true);
    setShowResetPinForm(false); // Ensure pin form is closed
    setPasswordValidationError(true);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleResetPinClick = () => {
    setShowResetPinForm(true);
    setShowResetPasswordForm(false); // Ensure password form is closed
    setPin("");
    setConfirmPin("");
    setPassword("");
    setPinValidationError(true);
  };

  const handleAccessParametersClick = () => {
    setShowAccessParametersForm(true);
    setShowResetPasswordForm(false);
    setShowResetPinForm(false);
  };

  const handleCancelClick = () => {
    setShowResetPasswordForm(false);
    setShowResetPinForm(false); // Close both forms on cancel
  };

    const handleSaveClick = async () => {
        if (showResetPasswordForm) {
        if (oldPassword === "" || newPassword === "" || confirmPassword === "") {
            setPasswordValidationError(false);
            return;
        }
        setPasswordValidationError(true);
        setIsLoading(true);
        const payload = {
            pid: getLogedPid(),
            old_password: oldPassword,
            new_password: newPassword,
            confirm_password: confirmPassword,
          };
        try {
            const response = await savePassword({ ...payload });
            if (response.error) {
              toast.error("Failed to save: " + response.error);
            } else if (response.data?.response?.code === 0) {
              toast.success("PASSWORD updated successfully");
              setOldPassword("");
              setNewPassword("");
              setConfirmPassword("");
            } else {
              setOldPassword("");
              setNewPassword("");
              setConfirmPassword("");
              toast.error("Failed to save: " + response.data?.response?.msg);
            }
          } catch (error) {
            console.error('Failed to change password:', error);
          }finally {
            setIsLoading(false);
          }
        }
    };
    const handleSavePin = async () => {
        if (showResetPinForm) {
          if (pin === "" || confirmPin === "" || password === "") {
            setPinValidationError(false);
            return;
          }
          setPinValidationError(true);
          setIsLoading(true);
          const payload = {
            pid: getLogedPid(),
            pincode: pin,
            confirm_pincode: confirmPin,
            password: password,
          };
        try {
            const response = await savePin({ ...payload });
            if (response.error) {
              toast.error("Failed to save: " + response.error);
            } else if (response.data?.response?.code === 0) {
              toast.success("PIN updated successfully");
              setPin("");
              setConfirmPin("");
              setPassword("");
              const user = getLoggedinUser();     setLocalStorage("session", { ...user, pincode: pin });
            } else {
              setPin("");
              setConfirmPin("");
              setPassword("");
              toast.error("Failed to save: " + response.data?.response?.msg);
            }
          } catch (error) {
            console.error('Failed to change password:', error);
          }finally {
            setIsLoading(false);
          }
        }
    };

  return (
    <>
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 items-center justify-between sm:flex-nowrap">
        <div>
          <h3 className="text-base font-semibold leading-6 text-gray-900">Settings</h3>
        </div>
      </div>
      <div className="flex">
        <div className="flex-none bg-white p-3 text-start" style={{ width: '20%' }}>
          <div className="mb-2">
            <a href="#" onClick={handleResetPasswordClick} className="text-lg text-blue-600 hover:underline">
              Reset Password
            </a>
          </div>
          <div className="mb-2">
            <a href="#" onClick={handleResetPinClick} className="text-lg text-blue-600 hover:underline">
              Reset PIN
            </a>
          </div>
          <div className="mb-2">
            <a href="#" onClick={handleAccessParametersClick} className="text-lg text-blue-600 hover:underline">
              Access parameters
            </a>
          </div>
        </div>

            {showResetPasswordForm && (
                <div className="flex-grow bg-white p-5" style={{ width: '70%' }}>
                {isLoading ? <FullScreenLoader /> : (
                <>
                <h4 className="text-lg font-semibold mb-4 border-b border-gray-300 pb-2 text-left">Reset Password</h4>
                <div className="flex mb-4 space-x-4">
                    <div className="flex-1">
                    <label className="block text-gray-700 text-left">
                        Old Password <span className="text-red-500">*</span>
                    </label>
                    <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                    {(oldPassword.trim() === "" && passwordValidationError == false) && (
                        <p className="text-red-500 text-left">Old Password is required.</p>
                    )}
                    </div>
                    <div className="flex-1">
                    <label className="block text-gray-700 text-left">New Password</label>
                    <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                    {(newPassword.trim() === "" && passwordValidationError == false) && (
                        <p className="text-red-500 text-left">New Password is required.</p>
                    )}
                    {(newPassword.trim() != "" && newPassword.length < 8) && (
                    <p className="text-red-500 text-left">Password should not be less than 8 characters.</p>
                    )}
                    </div>
                    <div className="flex-1">
                    <label className="block text-gray-700 text-left">
                        Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                    {(confirmPassword.trim() === "" && passwordValidationError == false) && (
                        <p className="text-red-500 text-left">Confirm Password is required.</p>
                    )}
                    {(confirmPassword.trim() != "" && confirmPassword != newPassword) && (
                        <p className="text-red-500 text-left">Confirm Password is not matching.</p>
                    )}
                    </div>
                </div>
                <div className="border-t border-gray-300 pt-4">
                    <div className="flex justify-end">
                    <button onClick={handleCancelClick} className="bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2">
                        Cancel
                    </button>
                    <button onClick={handleSaveClick}  className="bg-blue-600 text-white px-4 py-2 rounded">
                        Save
                    </button>
                    </div>
                </div>
                </>)}
                </div>
            )}

        {showResetPinForm && (
          <div className="flex-grow bg-white p-5" style={{ width: '70%' }}>
            {isLoading ? <FullScreenLoader /> : (
                <>
            <h4 className="text-lg font-semibold mb-4 border-b border-gray-300 pb-2 text-left">Reset PIN</h4>
            <div className="flex mb-4 space-x-4">
              <div className="flex-1">
                <label className="block text-gray-700 text-left">PIN</label>
                <input type="password" value={pin} maxLength="4" onChange={(e) => setPin(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                {(pin.trim() != "" && pin.length > 0 && pin.length < 4) && (
                    <p className="text-red-500 text-left">Length should be 4</p>
                )}
                {(pin.trim() === "" && pinValidationError == false) && (
                    <p className="text-red-500 text-left">PIN is required.</p>
                )}
              </div>
              <div className="flex-1">
                <label className="block text-gray-700 text-left">Confirm PIN</label>
                <input type="password" value={confirmPin} maxLength="4" onChange={(e) => setConfirmPin(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                {(confirmPin.trim() === "" && pinValidationError == false) && (
                    <p className="text-red-500 text-left">Confirm PIN is required.</p>
                )}
                {(confirmPin.trim() != "" && confirmPin.length > 0 && confirmPin.length < 4) && (
                    <p className="text-red-500 text-left">Length should be 4</p>
                )}
                {(confirmPin.length == 4 && confirmPin != pin) && (
                    <p className="text-red-500 text-left">Confirm PIN is not matching.</p>
                )}
              </div>
              <div className="flex-1">
                <label className="block text-gray-700 text-left">
                  Password <span className="text-red-500">*</span>
                </label>
                <input type="password"  value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded mt-1" />
                {(password.trim() === "" && pinValidationError == false) && (
                    <p className="text-red-500 text-left">Password is required.</p>
                )}
              </div>
            </div>
            <div className="border-t border-gray-300 pt-4">
              <div className="flex justify-end">
                <button onClick={handleCancelClick} className="bg-gray-300 text-gray-700 px-4 py-2 rounded mr-2">
                  Cancel
                </button>
                <button onClick={handleSavePin} className="bg-blue-600 text-white px-4 py-2 rounded">
                  Save
                </button>
              </div>
            </div>
            </>)}
          </div>
        )}
      </div>
    </>
  );
};

export default Settings;
